import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PackageCard from '../../../components/PackageCard/PackageCard';
import MovementItem from '../../../components/MovementItem/MovementItem';
import './PurchaseBucks.css';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';
//icons
import logo from '../../../assets/logo.png';
import mastercard from '../../../assets/mastercard.png';
import visa from '../../../assets/visa.png';
import iconNewCard from '../../../assets/iconNewcard.png';
//views
import PurchaseTokens from './PurchaseTokens/PurchaseTokens';
//services
import { paymentService } from '../../../services/Payment';

const PurchaseBucks = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null);
    const [packages, setPackages] = useState([]);
    const [movements, setMovements] = useState([]);
    const [balance, setBalance] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [language, setLanguage] = useState(null);
    const { token: tokenFromParams, language: languageFromParams } = useParams();

    useEffect(() => {
        if (tokenFromParams && languageFromParams) {
            setToken(tokenFromParams);
            setLanguage(languageFromParams);
            dataUser(tokenFromParams);
            fetchPackages(tokenFromParams);
        }
    }, [tokenFromParams, languageFromParams, selectedPackage]);

    useEffect(() => {
      if (language) {
          i18n.changeLanguage(language.toLowerCase());
      }
  }, [language]);

    const dataUser = async (currentToken) => {
      try {
        const response = await paymentService.getDataMe(currentToken || token);
        if(response.status === "success") {
            setUser(response.data);
            fetchMovements(currentToken, response.data.id);
            fetchBalance(currentToken, response.data.id);
            fetchPaymentMethods(currentToken, response.data.id);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    const fetchPackages = async (currentToken) => {
      try {
        const response = await paymentService.getPackages(currentToken || token);
        if(response.status === "success") {
            setPackages(response.data.items);
        }
      } catch (error) {
        console.error('Error fetching packages:', error);
      }
    };

    const fetchMovements = async (currentToken, userId) => {
      try {
        const response = await paymentService.getMovements(currentToken || token, userId, 1, 100000);
        if(response.status === "success") {
            setMovements(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching movements:', error);
      }
    };

    const fetchBalance = async (currentToken, userId) => {
      try {
        const response = await paymentService.getDataPurchase(currentToken || token, userId);
        if(response.status === "success") {
            setBalance(response.data);
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    };

    const fetchPaymentMethods = async (currentToken, userId) => {
      try {
        const response = await paymentService.getPaymentMethods(currentToken || token, userId);
        console.log('Payment methods:', response);
        if (response.status === "success") {
          const data = response.data.data.map(method => ({
            id: method.id,
            name: '****' + method.card?.last4,
            icon: iconCard(method.card?.brand),
            is_default: method.is_default
          }));
          setPaymentMethods(data);
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error);
      }
    };

    const iconCard = (brand) => {
      switch (brand.toUpperCase()) {
        case 'VISA':
          return <img src={visa} alt="Visa" style={{ width: '30px', height: '15px' }} />;
        case 'MASTERCARD':
          return <img src={mastercard} alt="Mastercard" sstyle={{ width: '30px', height: '24px' }} />;
        default:
          return <img src={iconNewCard} alt="New card" style={{ width: '30px', height: '24px' }} />;
      }
    }

    const handlePurchase = (id) => {
        const selected = packages.find(pkg => pkg.id === id);
        setSelectedPackage(selected);
    };

    const handleBack = () => {
        setSelectedPackage(null);
    };

    const handleResponse = (optionResponse) => {
      let title = t('responsePurchase.titleSuccess');
      let highlight = t('responsePurchase.highlightSuccess');
      let message = t('responsePurchase.successMessage');
      let titleButton = t('responsePurchase.accept');
      let isSuccessful = true;
      switch (optionResponse) {
        case "errorPurchase":
          title = t('responsePurchase.titleError');
          highlight = t('responsePurchase.highlightError');
          message = t('responsePurchase.errorMessage');
          titleButton = t('responsePurchase.tryAgain');
          isSuccessful = false;
          break;
        case "errorNoPaymentMethod":
          title = t('responsePurchase.titleErrorNoPaymentMethod');
          highlight = t('responsePurchase.highlightErrorNoPaymentMethod');
          message = t('responsePurchase.errorMessageNoPaymentMethod');
          titleButton = t('responsePurchase.tryAgainNoPaymentMethod');
          isSuccessful = false;
          break;
        case "successDefaultPayment":
          title = t('responsePurchase.titleSuccessDefaultPayment');
          highlight = t('responsePurchase.highlightSuccessDefaultPayment');
          message = t('responsePurchase.successMessageDefaultPayment');
          titleButton = t('responsePurchase.acceptDefaultPayment');
          isSuccessful = true;
          break;
        case "errorDefaultPayment":
          title = t('responsePurchase.titleErrorDefaultPayment');
          highlight = t('responsePurchase.highlightErrorDefaultPayment');
          message = t('responsePurchase.errorMessageDefaultPayment');
          titleButton = t('responsePurchase.tryAgainDefaultPayment');
          isSuccessful = false;
          break;
        default:
          title = t('responsePurchase.titleSuccess');
          highlight = t('responsePurchase.highlightSuccess');
          message = t('responsePurchase.successMessage');
          titleButton = t('responsePurchase.accept');
          isSuccessful = true;
          break;
      }
      navigate('/payments/successful-purchase', {
        state: {
          isSuccessful,
          title,
          highlight,
          message,
          titleButton
        }
      });
    };

    return (
        <div className="purchase-bucks-container">
            <div className="header">
                <div className="logo-container">
                    <img src={logo} alt="Logo" className="logo"/>
                </div>
                <div className="token-balance">
                  {Number(balance?.available_tokens || 0).toLocaleString('es-MX')}
                </div>
            </div>

            {selectedPackage ? (
                <PurchaseTokens 
                    onBack={handleBack}
                    selectedPackage={selectedPackage}
                    token={token}
                    user={user}
                    paymentMethods={paymentMethods}
                    responsePurchase={handleResponse}
                />
            ) : 
            <>
              <div className="packages-section">
                <h2>
                  {t('packages.title1')}
                  <span className="highlight">
                    {t('packages.highlight')}
                  </span>
                  {t('packages.title2')}
                </h2>
                
                <div className="packages-scroll">
                    <div className="packages-container">
                        {packages.map((pkg) => (
                            <PackageCard
                                key={pkg.id}
                                id={pkg.id}
                                tokens={pkg.tokens}
                                price={pkg.price}
                                originalPrice={pkg.originalPrice}
                                purchase={handlePurchase}
                            />
                        ))}
                    </div>
                </div>
              </div>

              <div className="movements-section">
                  <h3>{t('packages.movements')}</h3>
                  <div className="movements-list">
                      {movements.length > 0 && movements.map((movement, index) => (
                          <MovementItem
                              key={index}
                              action={movement.action}
                              transaction_type={movement.transaction_type}
                              tokens_obtained={movement.tokens_obtained}
                              tokens_spent={movement.tokens_spent}
                              created_at={movement.created_at}
                          />
                      ))}
                  </div>
              </div>
            </>}
        </div>
    );
};

export default PurchaseBucks;